import { Stack, Typography } from "@mui/material";
import UserAvatar from "@entrilia/shared/components/UserAvatar";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";

interface Props {
  userName: string;
  timestamp?: string;
}

const UserWithTimestamp = ({ userName, timestamp }: Props) => {
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center", flex: 1, minWidth: 0 }}>
      <UserAvatar userName={userName} size="small" />
      <Stack spacing={0.25} sx={{ flex: 1, minWidth: 0 }}>
        <Typography>{userName}</Typography>
        {timestamp && (
          <Typography variant="caption" color="textSecondary">
            {convertISODateTime(timestamp)}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default UserWithTimestamp;
